import { render, staticRenderFns } from "./CACertificate.vue?vue&type=template&id=de247b54&"
import script from "./CACertificate.vue?vue&type=script&lang=js&"
export * from "./CACertificate.vue?vue&type=script&lang=js&"
import style0 from "./CACertificate.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports